export const payment = {
  expense: 'Despesas',
  revenue: 'Receitas',
  all: 'Todos',
};

export function getName(value) {
  return payment[value];
}
